import { useCallback, useEffect } from 'react'

import { remove } from 'local-storage'

const LS_KEY = 'buildpass-custom-cursor'

type Props = {
  children?: React.ReactNode
}

export const CustomCursors: React.FC<Props> = () => {
  const setPointer = useCallback(() => {
    document.body.style.cursor = 'auto'
    remove(LS_KEY)
  }, [])

  useEffect(() => {
    setPointer()
  }, [setPointer])

  return <></>
}
